export const excludedList = [
  'caseId',
  'returnReason',
  'country',
  'sn',
  'orderType',
  'parentCaseId',
  'toolbox_id',
];
export default (isInternal, param) => {
  return isInternal && excludedList.includes(param);
}
